export default "__VITE_ASSET__f3473da4__"